import * as React from 'react';
import { withRouter, RouteComponentProps, Link } from 'react-router-dom';
import { MutationFunc } from 'react-apollo';
import { Divider, Row, Col, Button, notification } from 'antd';

import { Title } from '../../../components/Layout/components';
import Form from '../../../components/Form';
import GeneralSettingsCol from './components/General';
import ValuesSettingsCol from './components/Values';

interface ICustomerDetailProps extends RouteComponentProps<{ eshop: string }> {
  domain: string;
  customer: GQL.ICustomer;
  createForceLogin: MutationFunc;
  updateJSONPricesDownloadToken: MutationFunc;
  onSave: (customer: GQL.ICustomer) => void;
  onCancel: () => void;
}

interface ICustomerDetailState {
  customer: GQL.ICustomer;
}

class CustomerDetail extends React.Component<ICustomerDetailProps, ICustomerDetailState> {

  public constructor(props: ICustomerDetailProps) {
    super(props);

    this.state = {
      customer: props.customer,
    };

    this.onChange = this.onChange.bind(this);
    this.save = this.save.bind(this);
    this.onTokenSave = this.onTokenSave.bind(this);
  }

  public render() {
    const { customer } = this.state;
    const domain = this.props.match.params.eshop;

    const customerName: Array<String> = [];
    if (customer.invoiceLastName) {
      customerName.push(customer.invoiceLastName);
    }
    if (customer.invoiceFirstName) {
      customerName.push(customer.invoiceFirstName);
    }

    return (
      <div>
        <Title
          extra={
            <React.Fragment>
              <Button type={'default'} size={'small'} onClick={(e: any) => this.onLoginToEshop()}>
                Login to eshop as customer
              </Button>
              <Divider type={'vertical'} />
              <Link to={`/${domain}/application/orders/${customer.id}`} className={'ant-btn ant-btn-default ant-btn-sm'}>
                Customer orders
              </Link>
            </React.Fragment>
          }
        >
          {customer
            ? `Customer ${customerName ? `"${customerName.join(' ')}"` : ''}`
            : `Customer`}
        </Title>

        <Divider />
        <Form
          onSubmit={this.save}
          onCancel={this.props.onCancel}
        >
          <Row>
            <Col md={24} lg={11}>
              <GeneralSettingsCol
                customer={customer}
                onChange={this.onChange}
                onTokenSave={this.onTokenSave}
              />
            </Col>
            <Col lg={1} />
            <Col md={24} lg={12}>
              <ValuesSettingsCol
                domain={this.props.domain}
                customer={customer}
                onChange={this.onChange}
              />
            </Col>
          </Row>
        </Form>
      </div>
    );
  }

  private onChange(e: any, language?: string) {
    const { name, value, checked } = e.target;

    const inputValue = (value !== undefined ? value : checked);

    const newValue = (language
      ? { [name]: { ...this.state.customer[name], [language]: inputValue } }
      : { [name]: inputValue });


    if(name === 'companyVatNumber' && inputValue === '') {
      newValue[name] = null;
      newValue['pohodaCustomerId'] = null;
    }

    this.setState({
      customer: { ...this.state.customer, ...newValue }
    });
  }

  private async save() {
    this.props.onSave({...this.state.customer});
  }

  private async onLoginToEshop() {
    const result = await this.props.createForceLogin({
      variables: {
        customerId: this.props.customer.id,
      }
    });

    if (
      result && 
      result.data && 
      result.data.createForceLogin && 
      result.data.createForceLogin.callbackUrl
    ) {
      window.open(`${result.data.createForceLogin.callbackUrl}`, `_blank`);
    }
  }

  private async onTokenSave() {
    this.props.updateJSONPricesDownloadToken({
      variables: {
        customerId: this.state.customer.id,
        newToken: this.state.customer.jsonPricesDownloadToken,
      }
    })
    .catch(e => {
      this.setState({customer: {
        ...this.state.customer,
        jsonPricesDownloadToken: this.props.customer.jsonPricesDownloadToken,
      }});
      notification['error']({
        message: 'Token change failed',
        description: 'Token has not been changed',
      });
    });
  }
}

export default withRouter(CustomerDetail);



// WEBPACK FOOTER //
// ./src/scenes/Customers/CustomerDetail/CustomerDetail.tsx